import { render, staticRenderFns } from "./EventInformation.vue?vue&type=template&id=3c6146e7"
import script from "./EventInformation.vue?vue&type=script&lang=ts"
export * from "./EventInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports